import React from 'react';
import { saveAs } from 'file-saver';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';

// Files (e.g. PDF reports) arrive base64-encoded with the answer. They are not kept in localStorage,
// so after a reload only the name is left and the user is asked to request the report again.
export const stripFileData = (chat) =>
  chat.files ? { ...chat, files: chat.files.map(({ name }) => ({ name })) } : chat;

const downloadFile = (file) => {
  const bytes = Uint8Array.from(atob(file.data), (c) => c.charCodeAt(0));
  saveAs(new Blob([bytes], { type: file.content_type || 'application/octet-stream' }), file.name);
};

const FileDownloads = ({ files }) => {
  if (!files || !files.length) return null;
  return (
    <div className="project-card">
      {files.map((file) => (
        <div key={file.name} style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
          <PictureAsPdfOutlinedIcon sx={{ fontSize: 20, color: '#6a4cff' }} />
          <div className="project-card-files" style={{ flex: 1, minWidth: 0, overflowWrap: 'anywhere' }}>{file.name}</div>
          {file.data ? (
            <button type="button" className="project-card-button primary" onClick={() => downloadFile(file)}>
              Download PDF
            </button>
          ) : (
            <span className="project-card-files">No longer available - ask for the report again.</span>
          )}
        </div>
      ))}
    </div>
  );
};

export default FileDownloads;
